/*
 *
 * ManageApiKeyModal
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 25-Mar-2025
 */

import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import MerchantModal from '@nexidigital/merchantmodal'
import formattedMessage, { captions } from './languageModule'
import './ManageApiKeyModal.scss'

const ManageApiKeyModal = ({ actions, selectedTerminalId, showApiKeyResult, data, isLoading }) => {
  const [showCopiedMessage, setShowCopiedMessage] = useState(false)
  const intl = useIntl()
  const MASKED_KEY = '********'
  const { nexiaccountid, onCopy } = data
  const showing = showApiKeyResult?.apikey
  const copyText = showCopiedMessage ? intl.formatMessage(captions.copied) : intl.formatMessage(captions.copy)

  const timerRef = useRef(null)
  const copyTimerRef = useRef(null)

  const handleCopyApiKey = () => {
    navigator.clipboard.writeText(showApiKeyResult?.apikey)
    setShowCopiedMessage(true)

    if (copyTimerRef.current) {
      clearTimeout(copyTimerRef.current)
    }

    copyTimerRef.current = setTimeout(() => {
      setShowCopiedMessage(false)
    }, 2000)

    onCopy?.(handleClose)
  }

  const handleClose = () => {
    if (copyTimerRef.current) {
      clearTimeout(copyTimerRef.current)
    }
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
    actions.doResetShowApiKeyResult()
    actions.closePopup()
  }

  useEffect(() => {
    if (!showApiKeyResult?.apikey) return

    timerRef.current = setTimeout(() => {
      actions.doResetShowApiKeyResult()
    }, 5000)

    return () => {
      clearTimeout(timerRef.current)
    }
  }, [showApiKeyResult])

  useEffect(
    () => () => {
      actions.doResetShowApiKeyResult()
      if (copyTimerRef.current) {
        clearTimeout(copyTimerRef.current)
      }
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    },
    []
  )

  return (
    <MerchantModal
      title={formattedMessage.apiKey}
      description={formattedMessage.showApiKeyMessage(selectedTerminalId, showApiKeyResult?.apikey ?? MASKED_KEY)}
      onClose={handleClose}
      primaryButtonLabel={showing ? copyText : intl.formatMessage(captions.show)}
      primaryButtonLoading={isLoading}
      primaryAction={() => (showing ? handleCopyApiKey() : actions.doShowApiKey(nexiaccountid))}
      closeLabel={intl.formatMessage(captions.close)}
    />
  )
}

ManageApiKeyModal.propTypes = {
  showApiKeyResult: PropTypes.object,
  actions: PropTypes.object,
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  selectedTerminalId: PropTypes.string
}

ManageApiKeyModal.defaultProps = {
  showApiKeyResult: {},
  actions: {},
  data: {},
  isLoading: false,
  selectedTerminalId: ''
}

export default ManageApiKeyModal
